<!-- @Description 认知智能算法平台 -->
<template>
  <div class="product-cognitive">
    <div class="info">
      <div class="title">认知智能算法平台</div>
      <div class="content">
        认知智能算法平台构成我们技术架构的底层基础，统一整合计算资源、数据与算法模型，为智能应用的开发、训练、部署与管理提供一体化环境。平台可快速摄取并解析企业数据与领域知识，将碎片化信息转化为结构化、可复用的知识资产。为工业级与运营决策智能体提供有力支撑，推动企业级认知智能应用在多类运营场景中的落地与拓展。
      </div>
    </div>
    <div class="feature">
      <div class="highlight">
        <span class="highlight-number">20万+</span>
        <span class="highlight-unit">算子及模型的</span>
        <span class="highlight-sub">标准化库</span>
      </div>
      <div class="capabilities">
        <div
          class="capability-item"
          v-for="item in capabilities"
          :key="item.label"
        >
          <img :src="item.icon" :alt="item.label" class="capability-icon" />
          <div class="capability-label">{{ item.label }}</div>
        </div>
      </div>
      <img
        :src="illustrationImg"
        alt="认知智能算法平台"
        class="illustration-img"
      />
    </div>
  </div>
</template>
<script>
import iconHeterogeneous from "@/../static/img/product/cognitive/icon_heterogeneous.png";
import iconModelDev from "@/../static/img/product/cognitive/icon_model_dev.png";
import iconModelFinetune from "@/../static/img/product/cognitive/icon_model_finetune.png";
import iconModelDeploy from "@/../static/img/product/cognitive/icon_model_deploy.png";
import illustrationImg from "@/../static/img/product/cognitive/illustration.png";

export default {
  name: "product-cognitive",
  data() {
    return {
      illustrationImg,
      capabilities: [
        { label: "异构计算", icon: iconHeterogeneous },
        { label: "模型开发", icon: iconModelDev },
        { label: "模型微调", icon: iconModelFinetune },
        { label: "模型部署", icon: iconModelDeploy }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.product-cognitive {
  width: 100%;
  padding: 96px 0 0;
  .info {
    width: 100%;
    min-height: 432px;
    background: url("../../../../static/img/product/page_header_bg.png")
      no-repeat center / cover;
    overflow: hidden;
    padding-bottom: 44px;
    box-sizing: border-box;
    .title {
      margin-top: 48px;
      font-size: 44px;
      font-weight: 500;
      color: #08204d;
      line-height: 60px;
      text-align: center;
    }
    .content {
      padding: 0 68px;
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      margin-top: 24px;
      text-align: justify;
    }
  }
  .feature {
    padding: 44px 64px 64px;
    background: url("../../../../static/img/product/product_matrix_bg.png")
      no-repeat center / cover;
    .highlight {
      text-align: center;
      margin-bottom: 44px;
      line-height: 1.4;
      .highlight-number {
        font-size: 48px;
        font-weight: 700;
        color: #2632fa;
      }
      .highlight-unit {
        font-size: 32px;
        font-weight: 600;
        color: #2632fa;
      }
      .highlight-sub {
        display: block;
        font-size: 32px;
        font-weight: 600;
        color: #2632fa;
        margin-top: 8px;
      }
    }
    .capabilities {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: 44px;
      .capability-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .capability-icon {
          width: 56px;
          height: 56px;
          border-radius: 12px;
          margin-bottom: 12px;
        }
        .capability-label {
          font-size: 22px;
          font-weight: 400;
          color: #555e6e;
          line-height: 32px;
          text-align: center;
          white-space: nowrap;
        }
      }
    }
    .illustration-img {
      width: 100%;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/cognitive/index.vue